<template>
  <div class="partner-profile">
    <LoadingOverlay v-if="isLoading" />
    <CRow>
      <CCol md="6">
        <CCard>
          <CCardBody>
            <h3 class="text-primary main-title">Create Partner Profile</h3>
            <CRow>
              <CCol md="12">
                <CRow name="description" class="mb-3">
                  <label class="col-lg-12 col-md-12">Description</label>
                  <div class="col-lg-12 col-md-12 col-sm-12">
                    <ValidationProvider v-slot="{ errors }">
                      <TextArea
                        name="description"
                        :value="partner.description"
                        :error="errors[0]"
                        @input="handleInput"
                        :rows="20"
                      />
                    </ValidationProvider>
                  </div>
                </CRow>
              </CCol>
            </CRow>
            
            <CRow>
              <CCol md="12">
                <div class="d-flex justify-content-end">
                  <CButton color="primary" type="button" @click="updateLink">Generate</CButton>
                </div>
              </CCol>
            </CRow>
          </CCardBody>
        </CCard>
      </CCol>

      <CCol md="6">
        <div class="h-100">
          <PreviewPartnerProfile :link="link"></PreviewPartnerProfile>
        </div>
      </CCol>
    </CRow>
  </div>
</template>
<script>
import PreviewPartnerProfile from "@/containers/PartnerProfile/PreviewPartnerProfile.vue";
import Vue from "vue";
import TextArea from "@/components/reusable/Fields/TextareaInput";

export default {
  name: "CreatePartnerProfile",
  components: {
    PreviewPartnerProfile,
    TextArea
  },
  data() {
    return {
      isLoading: false,
      partner: {
        description: ''
      },
      link: null
    };
  },
  methods: {
    handleInput(name, value) {
      Vue.set(this.partner, name, value);
    },
    updateLink() {
      // TODO: Implement link generation logic
      this.isLoading = true;
      // Simulate API call delay
      setTimeout(() => {
        this.isLoading = false;
        // Generate a mock link for demonstration
        console.log('Link generated successfully');
      }, 1000);
    }
  }
};
</script>
